import { useQuery } from '@tanstack/react-query';
import { getDefaultStatusConfig } from 'services/api/WorkflowServiceAPI';
import { queryKeys } from '../queryKeys';

/** Tenant-scoped but otherwise constant, so it never goes stale in a session. */
export const useGetDefaultStatusConfig = (isEnabled = true) => {
    const { data, isLoading, ...rest } = useQuery({
        queryKey: queryKeys.defaultStatusConfig,
        queryFn: getDefaultStatusConfig,
        enabled: isEnabled,
        staleTime: Infinity,
    });

    return { defaultStatusConfig: data, isDefaultStatusConfigLoading: isLoading, ...rest };
};
